import { render, staticRenderFns } from "./TitlePlus.vue?vue&type=template&id=116d9260&scoped=true"
import script from "./TitlePlus.vue?vue&type=script&lang=js"
export * from "./TitlePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d9260",
  null
  
)

export default component.exports